export interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

interface FilterBarProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterBar({ options, value, onChange, className = '' }: FilterBarProps) {
  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      {options.map(option => {
        const isActive = value === option.value;
        return (
          <button
            key={option.value}
            onClick={() => onChange(option.value)}
            className={`px-5 py-2.5 rounded-xl font-label font-bold text-xs uppercase tracking-widest transition-all duration-200 outline-none focus:outline-none 
              ${
                isActive
                  ? 'bg-primary text-on-primary shadow-level2 scale-[1.02]'
                  : 'bg-surface-container-low text-on-surface-variant hover:bg-surface-container-high/60'
              }`}
          >
            {option.label}
            {option.count !== undefined && (
              <span
                className={`ml-2 text-[10px] font-black opacity-60 ${isActive ? 'text-on-primary' : 'text-primary'}`}
              >
                {option.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
